import { handleUrl, myHeadersWithTokenContentType } from '../global';
import { BlockageData, DetailProps } from './types';

export const createBlockage = (data: BlockageData): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/calendar-blockages`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const deleteBlockage = (blockedId: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/calendar-blockages/${blockedId}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const editBlockage = (
  data: BlockageData,
  blockedId: number
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/calendar-blockages/${blockedId}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
